module.exports = __webpack_public_path__ + "img/bot_warning.f8e2d3af.png";